import React, { useState } from "react";
import { LegalDoc } from "./LegalDoc";
import "./AcceptLegal.css";
import DivButton from "./Generic/DivButton";

export function AcceptLegal(props) {
  const [shown, setShown] = useState(
    props.new === undefined || props.new === true ? true : false
  );
  const [EULA, setEULA] = useState(false);
  const [PrivacyPolicy, setPrivacyPolicy] = useState(false);
  const [TermsOfUse, setTermsOfUse] = useState(false);
  const [WebsiteDisclosureNotes, setWebsiteDisclosureNotes] = useState(false);

  function AcceptedAll() {
    localStorage.setItem(props.email + " accepted", true);
    setShown(false);
  }
  if (shown)
    return (
      <div className={"LegalOverlay"}>
        <div className="LegalContainer">
          <h2>Legal Documents</h2>
          <div>Please accept the documents below to proceed. </div>
          <div>
            <LegalDoc
              handleAccept={() => {
                setEULA(true);
              }}
              classList={EULA ? "disabledButton" : ""}
              Dev={props.Dev}
              DocURL="https://qfp-logos.s3.amazonaws.com/legal/EULA+Final.pdf"
            >
              <div className={EULA ? "tag" : "hidden"}>Accepted!</div>
              EULA
            </LegalDoc>
            <LegalDoc
              handleAccept={() => {
                setPrivacyPolicy(true);
              }}
              classList={PrivacyPolicy ? "disabledButton" : ""}
              Dev={props.Dev}
              DocURL="https://qfp-logos.s3.amazonaws.com/legal/Privacy+Policy+Draft+Final.pdf"
            >
              <div className={PrivacyPolicy ? "tag" : "hidden"}>Accepted!</div>
              Privacy Policy
            </LegalDoc>
            <LegalDoc
              handleAccept={() => {
                setTermsOfUse(true);
              }}
              classList={TermsOfUse ? "disabledButton" : ""}
              Dev={props.Dev}
              DocURL="https://qfp-logos.s3.amazonaws.com/legal/Terms+of+Use+Final.pdf"
            >
              <div className={TermsOfUse ? "tag" : "hidden"}>Accepted!</div>
              Terms of Use
            </LegalDoc>
            <LegalDoc
              handleAccept={() => {
                setWebsiteDisclosureNotes(true);
              }}
              classList={WebsiteDisclosureNotes ? "disabledButton" : ""}
              Dev={props.Dev}
              DocURL="https://qfp-logos.s3.amazonaws.com/legal/Web+site+Disclosure+Notes+Final.pdf"
            >
              <div className={WebsiteDisclosureNotes ? "tag" : "hidden"}>
                Accepted!
              </div>
              Website Disclosure Notes
            </LegalDoc>
            {EULA && TermsOfUse && PrivacyPolicy && WebsiteDisclosureNotes ? (
              <DivButton onClick={AcceptedAll}>
                You're all good to go!
              </DivButton>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    );
  else return <></>;
}
